import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';

import scss from './EmptyConnectionsDisclaimer.module.scss';

function EmptyConnectionsDisclaimer() {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper}>
      <LinkOutlinedIcon className={scss.icon} />
      <span className={scss.title}>{t('noContentYet')}</span>
      <span className={scss.description}>{t('emptyContentDescription')}</span>
    </div>
  );
}

export default EmptyConnectionsDisclaimer;
